import { useEffect, useState } from "react";
import Button from "../Component/Common/Button";
import Logo from "../assets/images/MetubeLogo.png";
import Input from "../Component/Common/Input";
import { connect } from "react-redux";
import { projectName } from "../util/config";
import { apiInstance } from "../util/api-new";
import { setToast } from "../util/toast";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState({
    email: "",
  });

  const isEmail = (value) => {
    const val = value === "" ? 0 : value;
    const validNumber = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(val);
    return validNumber;
  };

  const handleSubmit = () => {
    const validEmail = isEmail(email);
    if (!email || !validEmail) {
      let error = {};
      if (!email) {
        error.email = "Email Is Required !";
      } else if (!validEmail) {
        error.email = "Email Is Invalid !";
      }
      return setError({ ...error });
    } else {
      let forgotPasswordData = {
        email: email,
      };

      apiInstance.post("forgot-password", forgotPasswordData).then((res) => {
        if (res.status) {
          setToast("success", "Password reset mail sent");
          const userType = sessionStorage.getItem("userType");
          if (Number(userType)) {
            navigate("/org/login", { replace: true });
          } else {
            navigate("/", { replace: true });
          }
        }
      });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("userType");
    };
  }, []);

  return (
    <div className="reset-password">
      <div className="dashboardHeader primeHeader mb-3 p-0">
        <div className="login-page">
          <div className="bg-login"></div>
          <div className="row">
            <div className="col-12 d-flex justify-content-center align-items-center">
              <div className="login-page-box ">
                <div className="login-box-img">
                  <img src={Logo} />
                  <h5>{projectName}</h5>
                </div>
                <div className="login-form">
                  <h6>Forgot Password</h6>
                  <Input
                    label={`Email`}
                    id={`loginEmail`}
                    type={`email`}
                    autoFocus
                    value={email}
                    errorMessage={error.email && error.email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          email: `Email Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          email: "",
                        });
                      }
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <div
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button className={"login-btn"} onClick={handleSubmit}>
                      Send Mail
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, {})(ForgotPassword);
